import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from '../../../components/NavBar';
import Cookies from 'js-cookie';
import ParceriasIframe from '../../../components/ParceriasIframe/ParceriasIframe';

const ParceriasCustom = () => {
	const [isAuthenticated, setIsAuthenticated] = useState(null); // null = ainda carregando
	const navigate = useNavigate();

	useEffect(() => {
		const userCookie = Cookies.get('user');

		if (!userCookie) {
			setIsAuthenticated(false);
			return;
		}

		try {
			const parsed = JSON.parse(userCookie);

			if (parsed?.token) {
				setIsAuthenticated(true);
			} else {
				setIsAuthenticated(false);
			}
		} catch {
			setIsAuthenticated(false);
		}
	}, []);

	// Enquanto verifica → NÃO renderiza nada (evita flash de erro)
	if (isAuthenticated === null) {
		return (
			<div className='flex justify-center items-center min-h-screen bg-white'>
				<p className='text-gray-600 text-sm'>Verificando acesso...</p>
			</div>
		);
	}

	return (
		<div className='flex flex-col mx-auto min-h-screen'>
			<NavBar />

			{!isAuthenticated ? (
				<section className='bg-[#004A80] mt-[150px] rounded-md w-[90%] sm:w-[70%] md:w-[60%] lg:w-[50%] mx-auto my-auto'>
					<div className='py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6'>
						<div className='mx-auto max-w-screen-sm text-center'>
							<h1 className='mb-4 text-white text-5xl sm:text-6xl lg:text-7xl tracking-tight font-extrabold'>
								401
							</h1>
							<p className='mb-10 text-2xl sm:text-3xl md:text-4xl tracking-tight font-bold text-slate-100'>
								Acesso Negado
							</p>
							<p className='mb-7 text-sm sm:text-base md:text-lg font-light text-gray-300'>
								Você não possui permissão para acessar este
								campo. Entre em contato com o administrador(a)
								da sua unidade.
							</p>
							<a
								href='/login'
								className='inline-flex hover:scale-105 transition-transform text-gray-300 bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-xl px-5 py-2.5 text-center my-4'>
								<span> Volte para a Tela de Login</span>
							</a>
						</div>
					</div>
				</section>
			) : (
				<div
					className=' bg-gray-100 mt-[80px] min-h-screen'
					/* style=
					{{
						width: '100%',
						height: '100%',
						marginTop: '80px',
					}}{' '}
					*/
				>
					<ParceriasIframe
						onReady={() => console.log('Parcerias carregado')}
						onAuthError={() => navigate('/login')}
					/>
				</div>
			)}
		</div>
	);
};

export default ParceriasCustom;
